import { tx, txt, useContent } from "@/content/ContentContext";
import { ArrowRight, BadgePercent, Link2, UserPlus } from "lucide-react";
import { Link } from "react-router-dom";
import { openResellerApply } from "@/components/ResellerApply";

const STEPS = () => ([
  [UserPlus, tx("landing.apply"), tx("landing.tell_us_who_you_are")],
  [Link2, tx("landing.share_your_link"), tx("landing.shops_that_sign_up_through")],
  [BadgePercent, tx("landing.earn_20"), tx("landing.you_earn_20_of_each")],
]);

export function ResellerSection() {
  useContent();
  return (
    <section id="reseller" className="grain scroll-mt-20 bg-slate-950 text-white" data-testid="landing-reseller">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-24 sm:px-8 lg:grid-cols-[1fr_1.4fr]">
        <div>
          <div className="eyebrow !text-amber-400">{txt("landing.reseller_program")}</div>
          <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">{txt("landing.bring_shops_to_smart_in")}</h2>
          <p className="mt-4 max-w-md text-slate-400">{txt("landing.for_it_shops_pos_installers")}</p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <button onClick={openResellerApply} data-testid="reseller-section-apply" className="flex h-12 items-center gap-2 rounded-xl bg-amber-500 px-6 font-bold text-slate-950 transition-[background-color,transform] hover:bg-amber-400 active:scale-[0.98]">
              {txt("landing.become_a_reseller")} <ArrowRight className="h-4 w-4" />
            </button>
            <Link to="/reseller" className="text-sm font-semibold text-slate-300 underline decoration-amber-500 decoration-2 underline-offset-4 hover:text-white" data-testid="reseller-section-login">{txt("landing.reseller_login")}</Link>
          </div>
        </div>
        <ol className="grid gap-4 sm:grid-cols-3">
          {STEPS().map(([Icon, t, d], i) => (
            <li key={t} className="rounded-2xl border border-white/10 bg-white/[0.03] p-5" data-testid={`reseller-step-${i}`}>
              <div className="flex items-center justify-between">
                <Icon className="h-6 w-6 text-amber-400" />
                <span className="font-mono text-xs text-slate-500">0{i + 1}</span>
              </div>
              <div className="mt-5 font-display text-lg font-bold">{t}</div>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{d}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
